export default "__VITE_ASSET__fd31f629__"